module.exports = __webpack_public_path__ + "static/media/brandImage.1888cc84.png";